const eplContent = {
  preview: `The Premier League 2024/25 season has delivered relentless drama from the opening weekend. 
  With the traditional top six reshuffling their squads significantly in the summer transfer window, 
  the title race remains wide open heading into the second half of the campaign. Liverpool have shown 
  the consistency of champions, while Manchester City continue to reinvent themselves following key 
  departures. Arsenal, so close in recent seasons, are determined this is finally their year.`,

  keyStories: [
    {
      title: "Liverpool's Title Charge",
      desc: "Arne Slot's men have maintained the intensity set by Klopp, with Mo Salah in inspired form and a defense that has conceded the fewest goals in the division."
    },
    {
      title: "Arsenal's Defining Season",
      desc: "Mikel Arteta's project reaches its most crucial point. With squad depth improved and Martinelli firing, the Gunners believe the title is within reach."
    },
    {
      title: "City's Post-Haaland Era Planning",
      desc: "Despite the striker's brilliance, City are building sustainable attacking structures that could outlast any individual dependency."
    },
    {
      title: "Chelsea's Endless Rebuild",
      desc: "Another summer of massive investment under Enzo Maresca raises questions about when the project truly takes flight."
    },
  ],

  titleContenders: [
    "Liverpool", "Arsenal", "Manchester City", "Chelsea", "Aston Villa"
  ],

  fullPreview: `
    <h3>Premier League 2024/25 — Complete Season Analysis</h3>
    <p>The English Premier League remains the world's most watched football competition, attracting 
    billions of viewers across 189 countries every matchweek. The 2024/25 season has reinforced exactly 
    why this division commands such global attention — unpredictability, intensity, and world-class talent 
    on every pitch, every weekend.</p>
    
    <h3>The Title Race</h3>
    <p>Liverpool under Arne Slot have proven that the transition from Jurgen Klopp need not be turbulent. 
    Playing a more controlled, possession-based style than his predecessor, Slot has maintained the winning 
    culture at Anfield while adding tactical nuance. Mohamed Salah continues to defy age, contributing goals 
    and assists at a remarkable rate.</p>
    
    <h3>Relegation Battle</h3>
    <p>The bottom three has seen significant movement throughout the season. Newly promoted sides face the 
    perennial challenge of Premier League quality, while established clubs fighting financial constraints 
    find survival increasingly difficult.</p>
    
    <h3>Key Statistics This Season</h3>
    <p>Goals per game average sits at 2.7 — above the historical Premier League average. This reflects 
    the attacking quality across the division and the tactical shift toward high pressing and quick 
    transitions that has swept through English football.</p>
    
    <h3>PitchFacts Prediction</h3>
    <p>Based on current form, fixture difficulty ratings, and historical patterns, PitchFacts projects 
    Liverpool as marginal title favorites, with Arsenal and Manchester City well positioned to mount 
    serious challenges in the final stretch of the season.</p>
  `,
};

export default eplContent;